import app from '@/app';

/* @ngInject */
function Fwd($resource) {
	return $resource(
		'api/fwds/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Fwd', Fwd);
